import {Button} from '@wandb/weave/components/Button';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback, useState} from 'react';
import {toast} from 'react-toastify';

import {TraceObjSchemaForBaseObjectClass} from '../wfReactInterface/objectClassQuery';
import {ConfirmDeleteDialog} from './ConfirmDeleteDialog';

const ENABLE_DEBUG_ACTIONS = false;

type DropdownComparisonViewActionsProps = {
  baseView: TraceObjSchemaForBaseObjectClass<'ComparisonView'> | null;
  onSaveNewView: () => void;
  onDeleteView: () => void;
};

const getObjSchemaUrl = (
  objSchema: TraceObjSchemaForBaseObjectClass<'ComparisonView'>
) => {
  return `weave:///${objSchema.project_id}/object/${objSchema.object_id}:${objSchema.digest}`;
};

export const DropdownComparisonViewActions = ({
  baseView,
  onSaveNewView,
  onDeleteView,
}: DropdownComparisonViewActionsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const onCopy = useCallback(() => {
    if (!baseView) {
      return;
    }
    const url = getObjSchemaUrl(baseView);
    const code = `import weave\nview = weave.ComparisonView.load('${url}')`;
    copyToClipboard(code);
    toast('Copied to clipboard');
  }, [baseView]);

  const onClickDelete = () => {
    setConfirmDelete(true);
  };

  return (
    <>
      <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenu.Trigger>
          <Button active={isOpen} variant="ghost" icon="overflow-horizontal" />
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content align="end">
            <DropdownMenu.Item onClick={onSaveNewView}>
              <Icon name="add-new" /> Save as new comparison
            </DropdownMenu.Item>
            {ENABLE_DEBUG_ACTIONS && (
              <>
                <DropdownMenu.Separator />
                <DropdownMenu.Item onClick={onCopy}>
                  <Icon name="copy" /> Copy code
                </DropdownMenu.Item>
              </>
            )}
            <DropdownMenu.Separator />
            <DropdownMenu.Item disabled={!baseView} onClick={onClickDelete}>
              <Icon name="delete" /> Delete comparison
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
      {confirmDelete && (
        <ConfirmDeleteDialog
          setConfirmDelete={setConfirmDelete}
          onDeleteCallback={onDeleteView}
        />
      )}
    </>
  );
};
